import React from "react";
import { useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import MobileGrid from "./mobileGrid";

export default function ResponsiveGrid({ primaryColumns, ...gridProps }) {
    const isMobile = useMediaQuery("(max-width:900px)");
    return (
        <>
            {isMobile ? (
                <MobileGrid primaryColumns={Array.isArray(primaryColumns) ? primaryColumns : primaryColumns ? [primaryColumns] : undefined} {...gridProps} />
            ) : (
                <DataGrid {...gridProps} />
            )}
        </>
    );
}
